import { WithRole } from 'components/WithRole';
import { Role } from 'domain/models';
import React from 'react';
import { Link } from 'react-router-dom';

import './Menu.scss';

export type ItemMap = { 
  [key: string]: ItemLink
} ;
export interface ItemInfo {
  className?: string;
  items: ItemMap;
}

export interface ItemLink {
  title: string;
  href?: string;
  onClick?: any;
  withRole?: Role;
  nested?: ItemMap;
}
export interface MenuProps {
  header?: string;
  items: ItemInfo[];
  right: ItemInfo[];
  withRole?: Role;
  onChange(item: string): void;
}

type UnfoldElementProps = { unfoldElement?: string; setUnfoldElement(element?: string): void };

export const Menu = (props: MenuProps) => {
  
  const [unfoldElement, setUnfoldElement] = React.useState<string>();

  return (<div className="navbar">
    {props.header && (<div className="navbar-header centered-text">{props.header}</div>)}
    {props.items.map(item => (<NavItem key='nav-item' 
      onClick={props.onChange} 
      item={item} 
      unfoldElement={unfoldElement} setUnfoldElement={setUnfoldElement} />))}

    {props.right && (<div className="right-items">
      {props.right.map(item => (<NavItem key='nav-item-right' onClick={props.onChange} item={item} unfoldElement={unfoldElement} setUnfoldElement={setUnfoldElement} />))}
    </div>)}
  </div>);
}

const NavItem = ({ item, onClick, unfoldElement, setUnfoldElement }: { item: ItemInfo; onClick(item: string): void } & UnfoldElementProps) => {
  return (<ul className={`navbar-nav ${item.className}`}>
    {Object.keys(item.items).map(id => {
      const navitem = item.items[id];
      return (
        <WithRole key={`with-role-nav-item-${id}`} role={navitem.withRole} action='destroy'>
          <li className="centered-text" key={`nav-item-${navitem.title}`}>
            <NavigationLink navitem={navitem} id={id} onClick={onClick} unfoldElement={unfoldElement} setUnfoldElement={setUnfoldElement} />
          </li>
        </WithRole>)
    })}
  </ul>);
}

type NavigationLinkProps = { navitem: ItemLink; id: string; onClick(item: string): void;  } & UnfoldElementProps;
const NavigationLink = ({ navitem, id, onClick, unfoldElement, setUnfoldElement }: NavigationLinkProps) => {

  const hasNested = navitem.nested !== undefined;

  if (hasNested) {
    const unfold = unfoldElement === id;
    return (<>
      <Link
        to={'#'}
        onClick={() => setUnfoldElement(unfold ? undefined : id)}>{navitem.title}<CaretIcon active={unfold} /></Link>
      {unfold && <NestedMenuContainer navitem={navitem} show={unfold} unfoldElement={unfoldElement} setUnfoldElement={setUnfoldElement} />}
    </>);
  }

  const doOnClick = () => {
    if (navitem.onClick) {
      navitem.onClick();
    }
    onClick(id);
  };

  return (
    <Link
      to={navitem.href || '#'}
      onClick={doOnClick}>{navitem.title}</Link>);
};

const NestedMenuContainer = ({ navitem, show, unfoldElement, setUnfoldElement }: { navitem: ItemLink; show: boolean } & UnfoldElementProps) => {
  const items: ItemInfo = {
    items: navitem.nested!
  }
  return (<div className='nested-menu'>
    <NavItem item={items} onClick={(item: string) => { }} unfoldElement={unfoldElement} setUnfoldElement={setUnfoldElement} />
  </div>)
}

const CaretIcon = ({ active }: { active: boolean }) => {
  const className = (active) ? 'caret-up' : 'caret';
  return (<span className={className}></span>);
}
